export default {
  DiamondIcon: () =>
    import(
      /* webpackChunkName: "DiamondIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/DiamondIcon.vue'
    ),
  CompactIcon: () =>
    import(
      /* webpackChunkName: "CompactIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/CompactIcon.vue'
    ),
  ClassicIcon: () =>
    import(
      /* webpackChunkName: "ClassicIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/ClassicIcon.vue'
    ),
  ConnectIcon: () =>
    import(
      /* webpackChunkName: "ConnectIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/ConnectIcon.vue'
    ),
  MixteIcon: () =>
    import(
      /* webpackChunkName: "MixteIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/MixteIcon.vue'
    ),
  TrapezIcon: () =>
    import(
      /* webpackChunkName: "TrapezeIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/TrapezeIcon.vue'
    ),
  TrapezeIcon: () =>
    import(
      /* webpackChunkName: "TrapezeIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/TrapezeIcon.vue'
    ),
  WaveIcon: () =>
    import(
      /* webpackChunkName: "WaveIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/WaveIcon.vue'
    ),
  ComfortIcon: () =>
    import(
      /* webpackChunkName: "ComfortIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/ComfortIcon.vue'
    ),
  UxIcon: () =>
    import(
      /* webpackChunkName: "UxIcon" */ '@/js/components/Shared/IconSelect/Icons/Frames/UxIcon.vue'
    ),
}
